module.exports = __webpack_public_path__ + "img/level_three.45550fa2.png";